export default {
  arrow: {
    left: {
      '16px': require('./chevron-left-16.png'),
    },
  },
};
